export default "__VITE_ASSET__24pVujRn__"